import { useState, useEffect } from 'react';
import { useReduxToken } from '@Hooks/reduxTokenHook/useReduxToken';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';

function useThemeChange() {

    const { token } = useReduxToken();
    const { activeUserPreferencesAll } = useReduxActiveUser();
    const [isDarkMode, setIsDarkMode] =  useState(window.matchMedia('(prefers-color-scheme: light)').matches);

    useEffect(() => {
        const targetHtml = document.querySelector('html');
        if (!targetHtml) return;
        const themePref = activeUserPreferencesAll?.theme;
        let theme;
        if (!token || token === 'void') {
            theme = isDarkMode ? 'dark' : 'light';
        } else if (!themePref || themePref === 'system') {
            theme = isDarkMode ? 'light' : 'dark';
        } else {
            theme = themePref;
        }
        targetHtml.setAttribute('data-theme', 'light');
    }, [token, isDarkMode, activeUserPreferencesAll?.theme]);
}

export default useThemeChange;